import { pathOr } from 'ramda';

import { setHeaders } from 'src/utilities/request';

import Request, { setData, setMethod, setURL } from '../index';
import { NODE_SERVICE_ENDPOINT } from '../nodeServices/constant';
import { getNamespaceName } from '../objects/namespaces';
import { MoxoConfigPayload } from 'src/pages/Applications/commons/Moxo/Client/types';

/**
 * @summary Get moxo auth token.
 */

// TODO: update base rouute
export const getMoxoToken = (data: MoxoConfigPayload) => {
  return Request<any>(
    setHeaders({
      namespace: getNamespaceName(),
      'requester-account-id': pathOr('', ['unique_id'], data),
    }),
    setURL(`${NODE_SERVICE_ENDPOINT}/moxo/token`),
    setMethod('POST'),
    setData(data),
  ).then((response) => response.data);
};
